import { useEffect } from "react";
import { CircleMarker, MapContainer, Popup, TileLayer, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import type { PessoaOnline } from "../../services";
import { cidadeDoLog, descreverAparelho } from "../aparelho";
import { pontosDoMapa, type Ponto } from "./calculos";

const Enquadrar = ({ pontos }: { pontos: Ponto[] }) => {
  const map = useMap();
  useEffect(() => {
    if (pontos.length === 0) return;
    if (pontos.length === 1) {
      map.setView([pontos[0].lat, pontos[0].lon], 11);
      return;
    }
    map.fitBounds(pontos.map((p) => [p.lat, p.lon] as [number, number]), { padding: [30, 30], maxZoom: 12 });
    // só reenquadra quando muda quem está no mapa, não a cada atualização de 30 s
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, pontos.map((p) => p.pessoa.userId).join(",")]);
  return null;
};

export const MapaAgora = ({ pessoas }: { pessoas: PessoaOnline[] }) => {
  const pontos = pontosDoMapa(pessoas);
  return (
    <MapContainer
      center={[-14.2, -51.9]}
      zoom={4}
      scrollWheelZoom={false}
      style={{ height: "100%", minHeight: 320, width: "100%", borderRadius: 8 }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Enquadrar pontos={pontos} />
      {pontos.map(({ pessoa, lat, lon, exato }) => (
        <CircleMarker
          key={pessoa.userId}
          center={[lat, lon]}
          radius={exato ? 9 : 8}
          pathOptions={{
            color: pessoa.online ? (exato ? "#137333" : "#1264C7") : "#9AA0A6",
            fillColor: pessoa.online ? (exato ? "#34A853" : "#8AB4F8") : "#DADCE0",
            fillOpacity: exato ? 0.9 : 0.5,
            weight: 2,
            dashArray: exato ? undefined : "4 3",
          }}
        >
          <Popup>
            <strong>{pessoa.userName || pessoa.userEmail}</strong>
            <br />
            {pessoa.online ? "Online" : "Saiu há pouco"} · {pessoa.screen ?? "—"}
            <br />
            {exato
              ? `Posição do aparelho${pessoa.accuracyM != null ? ` (±${pessoa.accuracyM} m)` : ""}`
              : `Cidade pelo IP: ${cidadeDoLog(pessoa) ?? "?"}`}
            <br />
            {descreverAparelho(pessoa.userAgent)} · {pessoa.ip}
          </Popup>
        </CircleMarker>
      ))}
    </MapContainer>
  );
};
